module.exports = __webpack_public_path__ + "img/js.9c28cb9.svg";